var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAaCreditsRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F9FAFB",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 24.5H18M18 28.5H21.5467C22.0869 28.5 22.357 28.5 22.6181 28.5466C22.85 28.5879 23.0761 28.6563 23.2919 28.7506C23.535 28.8567 23.7598 29.0065 24.2092 29.3062L24.7908 29.6938C25.2402 29.9935 25.465 30.1433 25.7081 30.2494C25.9239 30.3437 26.15 30.4121 26.3819 30.4534C26.643 30.5 26.9131 30.5 27.4533 30.5H28.5467C29.0869 30.5 29.357 30.5 29.6181 30.4534C29.85 30.4121 30.0761 30.3437 30.2919 30.2494C30.535 30.1433 30.7598 29.9935 31.2092 29.6938L31.7908 29.3062C32.2402 29.0065 32.465 28.8567 32.7081 28.7506C32.9239 28.6563 33.15 28.5879 33.3819 28.5466C33.643 28.5 33.9131 28.5 34.4533 28.5H38M18 23.2L18 32.8C18 33.9201 18 34.4802 18.218 34.908C18.4097 35.2843 18.7157 35.5903 19.092 35.782C19.5198 36 20.0799 36 21.2 36L34.8 36C35.9201 36 36.4802 36 36.908 35.782C37.2843 35.5903 37.5903 35.2843 37.782 34.908C38 34.4802 38 33.9201 38 32.8V23.2C38 22.0799 38 21.5198 37.782 21.092C37.5903 20.7157 37.2843 20.4097 36.908 20.218C36.4802 20 35.9201 20 34.8 20L21.2 20C20.0799 20 19.5198 20 19.092 20.218C18.7157 20.4097 18.4097 20.7157 18.218 21.092C18 21.5198 18 22.0799 18 23.2Z",
    stroke: "#0860C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaCreditsRounded);
export default __webpack_public_path__ + "static/media/aa-credits-rounded.c726ac8eaad5487b6e6a9d7c0cd9ec6d.svg";
export { ForwardRef as ReactComponent };